export const containsHtml = (text) => {
  
  const HtmlRegex = /<[a-z][\s\S]*>/i;
  const urlRegex = /([a-zA-Z\d]+:\/\/)?(\w+:\w+@)?([a-zA-Z\d.-]+\.[A-Za-z]{2,4})(:\d+)?(\/.*)?/i;

  return HtmlRegex.test(text) || urlRegex.test(text);
};

export default containsHtml;
